<template>
  <div>
    <v-layout v-if="dialog && email" row justify-center>
      <v-dialog
        :value="dialog"
        @input="reset()"
        persistent
        scrollable
        max-width="50vw"
      >
        <v-card>
          <v-card-title class="px-4">
            <div class="title">{{ $t('company.custom_email.model.title', {'emailType':DEFINES.CUSTOM_EMAILS.TYPE_STR[email.mail_type]})}}</div>
            <v-spacer></v-spacer>
            <v-btn
              class="mx-0 px-0"
              small
              dark
              icon
              color="grey"
              @click="reset()"
            >
              <v-icon small>$vuetify.icons.rms_close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-0 px-0" style="max-height: 80vh">
            <v-tabs grow color="grey lighten-3">
                <v-tabs-slider></v-tabs-slider>
                <v-tab href="#email-edit">{{ $t('company.custom_email.edit.title') }}</v-tab>
                <v-tab href="#email-preview">{{ $t('company.custom_email.preview.title') }}</v-tab>
            
                <v-tab-item class="px-4" value="email-edit">
                    <v-form ref="customizeEmail">
                        <v-layout row wrap>
                            <v-flex xs12 class="mt-4">
                                <div class="grey--text greyDarken2--text">
                                    <label><b>{{ $t('company.custom_email.notes.title') }} :- </b></label>
                                    <ul>
                                        <li class="pb-1">{{ $t('company.custom_email.note_1') }}</li>
                                        <li>{{ $t('company.custom_email.note_2') }}</li>
                                    </ul>
                                </div>
                            </v-flex>
                            <v-flex xs12 class="mt-4">
                                <v-textarea
                                v-model="email.mail_subject"
                                :value="email.mail_subject"
                                color="primary"
                                :label="$t('company.custom_email.email_subject.title')"
                                rows="1"
                                :rules="[rules.required, rules.min_length(2), rules.max_length(1000)]"
                                ></v-textarea>
                            </v-flex>
                            <v-flex xs12 class="mt-3">
                                <label for="mail_body" class="caption grey--text greyDarken2--text">{{ $t('company.custom_email.mail_body.title') }}</label>
                                <vue-editor
                                    id="mail_body"
                                    name="mail_body"
                                    class="mt-1"
                                    :value="email.mail_body"
                                    v-model="email.mail_body"
                                    :editor-toolbar="editorToolbar"
                                    :rules="[rules.required]"
                                    ref="vueeditor"
                                ></vue-editor>
                            </v-flex>
                            <v-flex xs12 class="mt-3">
                                <v-checkbox
                                v-model="email.is_active"
                                color="primary"
                                :label="'Active'"
                                >
                                    <template v-slot:append>
                                        <v-tooltip top color="white">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on">mdi-information-outline</v-icon>
                                        </template>
                                        <span
                                            class="greyDarken3--text body-1"
                                            v-html="$t('company.custom_email.active.tooltip')"
                                        ></span>
                                        </v-tooltip>
                                    </template>
                                </v-checkbox>
                            </v-flex>
                        </v-layout>
                        <v-divider class="mb-3"></v-divider>
                        <v-layout>
                            <v-flex xs12 class="text-md-right">
                                <v-btn
                                    color="grey"
                                    class="mt-0 ml-0"
                                    large
                                    dark
                                    @click="reset()"
                                    >{{ $t("rms.button.cancel") }}
                                </v-btn>
                                <v-btn
                                    large
                                    class="mt-0 mr-0"
                                    color="secondary"
                                    @click="save()"
                                    >{{ $t("rms.button.save") }}
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-tab-item>
                <v-tab-item class="px-4 pt-4" value="email-preview">
                    <CustomEmailPreview :email="email"></CustomEmailPreview>
                </v-tab-item>
            </v-tabs>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import rules from "@/validation";
import { VueEditor} from "vue2-editor";
import { mapGetters, mapState } from "vuex";
import CustomEmailPreview from "@/components/company/CustomEmailPreview";

export default {
    name: "CustomizeEmail",
    props: {
        email: {
            type: Object,
            default: null,
        },
        dialog:{
            type: Boolean,
            default: false,
        }
    },
    components:{
        VueEditor,
        CustomEmailPreview
    },
    data() {
        return {
            rules,
            editorToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline", "strike"],
                [
                { align: "" },
                { align: "center" },
                { align: "right" },
                { align: "justify" },
                ],
                ["link"],
                ["clean"],
                [{ 'direction': 'rtl' }],
            ],
        }
    },
    computed: {
        ...mapGetters({
            selected_company_id: "company/getSelected"
        }),
    },
    methods:{
        async save(){
            try {
                if (!this.$refs.customizeEmail.validate()) {
                    return false;
                }
                let action = this.email.id?'updateCustomEmail':'createCustomEmail';
                this.email.company_id = this.selected_company_id;
                await this.$store.dispatch(`company/${action}`, this.email);
                this.refresh();
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: this.DEFINES.SNACKBAR_ERROR_COLOR,
                });
            }
        },
        reset() {
            this.$emit('reset');
        },
        refresh(){
            this.$emit('reset');
            this.$emit('refresh');
        }
    }
}
</script>

<style scoped>

</style>